import { useFilterContext } from '@/context';

// Earliest date (YYYY-MM-DD) each audience data type is available from.
export const DATA_AVAILABILITY = {
  players: { label: 'Players', availableFrom: '2017-01-01' },
  uniques: { label: 'Uniques', availableFrom: '2026-09-01' },
  device: { label: 'Device', availableFrom: '2021-05-23' },
  gender: { label: 'Gender', availableFrom: '2025-10-02' },
  age: { label: 'Age', availableFrom: '2025-10-02' },
  location: { label: 'Location', availableFrom: '2014-04-01' },
} as const;

export type DataAvailabilityType = keyof typeof DATA_AVAILABILITY;

/**
 * Whether the range starts before `dataType` data is available. Checks `from` when given,
 * otherwise the page filter.
 */
const useIsBeforeDataAvailability = (dataType: DataAvailabilityType, from?: string): boolean => {
  const { filters } = useFilterContext();
  return (from ?? filters.dateRange.from) < DATA_AVAILABILITY[dataType].availableFrom;
};

export default useIsBeforeDataAvailability;
